import { getPrivateApi } from "../lib/axiosConfig";
import { GasOrder } from "../types/gasOrder.types";
import { AppError } from "./classes";

const api = getPrivateApi();
const endpoint = "/gas-orders/paid/station";

export const getPaidGasOrdersByStation = async (stationId: string): Promise<GasOrder[]> => {
  try {
    const { data } = await api.get<GasOrder[]>(`${endpoint}/${stationId}`);
    return data;
  } catch (error: any) {
    const errMsg = "Erro ao buscar abastecimentos";

    console.error(errMsg, error?.response ?? error);

    const message = error?.response?.data?.message ?? errMsg;

    throw new AppError(message, error?.response?.status ?? 500);
  }
};
